<template>
  <div class="subsOrderHistory">
    <div class="orderHistoryList">
        <div class="container">
            <template v-for="(his, index) in modhistory">
                <div 
                    :key="index"
                    @click="toggleexpand(his.id)"
                    class="orderHistoryItem">
                    <div class="row">
                        <div class="col-lg-8 col-md-6">
                            <div class="orderDetails">
                                <h2>ORDER #: {{his.order_number}} {{his.status == 'confirm' ? 'Delivered' : his.status}}</h2>
                                <h1>{{his.delivery_date | formatdate('MMMM D, YYYY')}}</h1>
                            </div>
                        </div>

                        <div class="col-lg-4 col-md-6">
                            <div class="orderSummaryPreview">
                                <span class="orderQTY">
                                    {{his.numberofboxes}} BOXES
                                </span>
        
                                <span class="orderDash">
                                    —
                                </span>
        
                                <span class="orderPrice">
                                    ${{his.total}}
                                </span>

                                <span 
                                    class="expandBtn">
                                    <b-icon icon="chevron-down"></b-icon>
                                </span>
                            </div>
                        </div>
                    </div>

                    <div 
                        v-show="expandRow == his.id"
                        :class="['orderMoreDetails', {'show' : expandRow == his.id}]">
                        <div class="row">
                            <div class="col-lg-8">
                                <box-item :orderboxes="his.orderboxitems"/>

                                <template v-if="his.order_event_time_range">
                                    <div class="ordereventaction">
                                        <b-btn class="mr-3" variant="outline-primary">Edit</b-btn>
                                        <b-btn variant="primary">Delete</b-btn>
                                    </div>
                                </template>
                            </div>

                            <div class="col-lg-4">
                                <more-details 
                                    :history="his"
                                    :orderboxeshistory="his.orderboxitems"/>
                            </div>
                        </div>
                    </div>

                </div>
            </template>
            
           
        </div>

    </div>
</div>
</template>

<script>
//components
import boxItem from '@/components/boxItem.vue';
import historyMoreDetail from '@/components/orderHistoryMoreDetail.vue';

/**
 * Declerations
 */
// plugins
import axios from 'axios'
// import moment from 'moment'

// Helper
import Helper from '@/helpers/helper'
import {
        getCollections ,
        cleanrecord,
        addUpdateCollection, 
        newJob} from '@/helpers/localbase'

export default {
    components : {
        'box-item'    : boxItem,
        'more-details': historyMoreDetail
    },
    data() {
        return {
            expandRow: null,
            history  : []
        }
    },
    computed : {
        /**
         * Modified history properties
         */
        modhistory () {
            return this.history.slice().map(his => {
                his.orderboxitems = his.orderboxitems.map(box => {
                    box.flavors = box.flavors.map(f => {
                        f.id = f.flavor_id ? f.flavor_id : f.id
                        return f
                    })
                    return box
                })

                return his;
            })
        },
        /**
         * Login user
         */
        user() {
            return this.$store.state.user
        },
        /**
         * Netword status
         */
        isonline() {
            return this.$store.state.isonline
        }
    },
    filters : {
        /**
         * Formatting data via 
         * @param format 
         * @example 'MM/DD/YYYY'
         */
        formatdate(date, format) {
            return date ?  Helper.formatdate(date, format) : ''
        },
         /**
         * Get order box number
         * Convert object to array
         */
        getboxnumber(boxes){ 
            if(Array.isArray(boxes)) {
                return boxes.length
            } else if(typeof boxes == 'object') {
                const newbxes = Object.values(boxes);
                return newbxes.length
            }
        },
    },
    methods : {
       /**
        * Toggle expand history to show more details
        * @param {Number} id history id
        */
       toggleexpand(id) {
           this.expandRow = this.expandRow == id ? null : id;
       },
        /**
         * Get order history and 
         * save to indexeddb
         */
        async gethistory() {
            /**
             * Check if have user data
             * if none don't proceed
             */
            if(!this.user) {
                return;
            }

            const ihistory     = await getCollections({name : 'userorderhistory', filter : {key : 'user_id', value : this.user.id}})
                  this.history = ihistory.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));

            const url = '/get_user_orders';
            const res = await axios.get(url).catch(err => console.log(err))

            if(res && res.data) {
                let newdatas     = res.data.data.map(history => {

                    /**
                     * Check if box items is not array then convert to array
                     */
                    history.orderboxitems = !Array.isArray(history.orderboxitems) ? Object.values(history.orderboxitems) : history.orderboxitems


                    return history;
                });
                
                newdatas.sort((a,b) => new Date(b.created_at) - new Date(a.created_at));


                this.history = newdatas;

                /**
                 * add / update indexeddb
                */
                newdatas.forEach(data => {
                    addUpdateCollection({name : 'userorderhistory', data : data})
                });

                  /**
                 * Clean up records
                 * For trash data
                 */
                cleanrecord(newdatas, ihistory, 'id', 'userorderhistory');
            } else if(!this.isonline) {
                /**
                 * IF offline register request to job
                 */
                newJob({
                    url : url,
                    method : "GET",
                    callback : (data, options) => {
                        if(data) {
                            const newdatas     = data.data;
                            /**
                             * add / update indexeddb
                            */
                            newdatas.forEach(data => {
                                options.db.addUpdateCollection({name : 'userorderhistory', data : data})
                            });
                        }
                    }
                })
            }
        }
    },
    /**
     * Call function before component rendered
     */
    async beforeMount() {
        await this.gethistory()
    }

    
}
</script>

<style lang="scss">

</style>